import React, {ReactNode} from "react";
import {RootStateOrAny, useSelector} from "react-redux";
import {selectAppIsInitialized, selectModules, selectParameters, selectTheme} from "@/Redux/App/AppReducer";
import LoadingElement from "@/Components/Loading/LoadingElement";
//import {selectIsLoggedIn, ViewerState} from "../Redux/Auth/AuthReducer";
import {relayAuthEnvironment, relayGuestEnvironment,} from "@/RelayEnvironment";
import RelayModernEnvironment from "relay-runtime/lib/store/RelayModernEnvironment";
import {RelayEnvironmentProvider} from "relay-hooks";
import {ThemeProvider} from "@mui/material/styles";
import {Button, CssBaseline, GlobalStyles} from "@mui/material";
import {Toaster} from "react-hot-toast";
import CustomToast from "@/Components/CustomToast/CustomToast";
import {CustomToastContainer} from "@/Components/CustomToast/CustomToastContainer";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import WebsiteComponent from "@/Containers/WebsiteComponent";
import ManagerComponent from "@/Containers/ManagerComponent";
//import {createAppTheme} from "../Style/Theme";
import moment from "moment/moment";
import "moment/locale/de";
import {isMobileOnly} from "react-device-detect";
import {createAppTheme} from "@/Style/Theme";
import colors from "@/Style/Colors";
import {selectIsLoggedIn, ViewerState} from "@/Redux/Auth/AuthReducer";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import _ from "lodash";
import ModuleCrentweb6NotActiveScreen from "@/Domains/AuthenticationManagement/ModuleCrentweb6NotActiveScreen";
import {Environment, QueryRenderer} from "react-relay";
import {graphql} from "relay-runtime";
import {logger} from "@/Logger";
import LoginExpiredModal from "@/Components/LoginExpiredModal/LoginExpiredModal";
import {
    MainComponentQueryRendererQuery,
    MainComponentQueryRendererQueryResponse
} from "@/Containers/__generated__/MainComponentQueryRendererQuery.graphql";

moment().locale("de");

export default function MainComponent() {
    const {t, translations} = useTranslation();

    const isAppInitialized = useSelector((state) =>
        selectAppIsInitialized(state),
    );
    const isLoggedIn = useSelector((state) =>
        selectIsLoggedIn(state as ViewerState),
    );
    const themeMode = useSelector((state) =>
        selectTheme(state as RootStateOrAny),
    );

    const theme = createAppTheme(themeMode, colors);


    if (!translations) {
        return (
            <>
                <ThemeProvider theme={theme}>
                    <LoadingElement/>
                </ThemeProvider>
            </>
        );
    }

    const modules = useSelector((state) =>
        selectModules(state),
    );

    const parameters = useSelector((state) =>
        selectParameters(state as RootStateOrAny)
    );

    const shopLinkParameter = parameters?.data?.find((parameter: any) => parameter.parameter == 'SSHOP_LINK')

    const renderRoutes = (viewData?: MainComponentQueryRendererQueryResponse) => {
        return (
            <Router>
                <Switch>
                    <Route path="/manager">
                        <Switch>
                            {/*Website*/}
                            <Route path="/">
                                <ManagerComponent isLoggedIn={isLoggedIn} viewData={viewData}/>
                            </Route>
                        </Switch>
                    </Route>
                    {/*Website*/}
                    <Route path="/">
                        <WebsiteComponent/>
                    </Route>
                </Switch>
            </Router>
        );
    };

    const renderDemoButton = () => {
        if (!_.isEqual(modules, {timestamp: null, data: null}) && modules) {
            if (!modules["CrentWeb6"]) {
                return shopLinkParameter?.value && <Button
                  style={{
                      position: "fixed",
                      bottom: "20px",
                      right: "20px",
                      backgroundColor: "#ff4d4f",
                      color: "white",
                      padding: "12px 18px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                      zIndex: 9999,
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                  }}
                  onClick={() => {
                      window.open(shopLinkParameter?.value, "_blank")
                  }}
                >
                  🔔 Demo-Modus – Jetzt abonnieren
                </Button>
            }
        }
    }

    if (isMobileOnly) {
        return <>Bitte wechsle dein Device</>;
    }

    if (!isAppInitialized) {
        return (
            <>
                <ThemeProvider theme={theme}>
                    <LoadingElement/>
                </ThemeProvider>
            </>
        );
    }

    if (!_.isEqual(modules, {timestamp: null, data: null}) && modules) {
        if (!modules["CrentWeb6"]) {
            return <ModuleCrentweb6NotActiveScreen/>
        }
    }

    const environment = isLoggedIn
        ? relayAuthEnvironment()
        : relayGuestEnvironment();

    const autoDismissTimeout = 5000;

    const MyCustomToastContainer = (props: ToastContainerProps) => {
        return <CustomToastContainer {...props} />;
    };

    const MyCustomToast = ({
                               appearance,
                               children,
                           }: {
        appearance: string;
        children: ReactNode;
    }) => {
        return (
            <CustomToast
                appearance={appearance}
                children={children}
                autoDismissTimeout={autoDismissTimeout}
            />
        );
    };

    return (
        <RelayEnvironmentProvider
            environment={environment as RelayModernEnvironment}
        >
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <GlobalStyles
                    styles={{
                        body: {
                            backgroundColor: theme.palette.background.default,
                        },
                    }}
                />
                <Toaster position="top-right" reverseOrder={false} toastOptions={{
                    style: {
                        marginTop: "50px"
                    },
                }}/>

                {isLoggedIn && <QueryRenderer<MainComponentQueryRendererQuery>
                    //@ts-ignore
                  environment={relayAuthEnvironment() as Environment}
                  query={graphql`
                      query MainComponentQueryRendererQuery($rightsFilter: [String]) {
                          viewer {
                              rights(filter: $rightsFilter) {
                                  right
                              }
                          }
                      }
                  `}
                  cacheConfig={{force: true}}
                  variables={{
                      rightsFilter: [
                          "ABF_ALLE",
                          "VERM_LIEF_BEARB",
                          "VERKAUF"
                      ]
                  }}
                  render={(result) => {
                      logger.log("BookingMainQueryRenderer Query:", result);

                      if (result.props?.viewer === null) {
                          return <LoginExpiredModal/>;
                      }

                      if (!result.props?.viewer) {
                          return <LoadingElement/>;
                      }

                      return (
                          <>
                              {renderRoutes(result.props)}
                          </>
                      );
                  }}
                />}
                {!isLoggedIn && <>
                    {renderRoutes()}
                </>}
            </ThemeProvider>
        </RelayEnvironmentProvider>
    );
}
